<template>
  <div class="answerInputWrapper">
    <div class="answerHeader">
      <span>{{'답변' + answerCount + '.'}}</span>
      <span class="answerDeleteText" v-if="answerCount > 2" v-on:click="setAnswerDelete">삭제</span>
    </div>
    <div ref="answerContentImg" class="answerContentImg">
      <input-img-answer v-bind:answer-count="answerCount" v-bind:style="style.answerContentImgHeight"></input-img-answer>
    </div>
    <input-text-answer v-bind:answer-count="answerCount"></input-text-answer>
  </div>
</template>

<script>
import inputTextAnswer from '../../board/elements/enrollInputTextAnswer.vue'
import inputImgAnswer from '../../board/elements/enrollInputImgAnswer.vue'

export default {
  components: {
    'input-text-answer': inputTextAnswer,
    'input-img-answer': inputImgAnswer
  },
  props: {
    answerCount: Number
  },
  data () {
    return {
      style: {
        answerContentImgHeight: ''
      }
    }
  },
  methods: {
    setAnswerDelete: function () {
      if(this.answerCount === 3) {
        // 3번째 답변을 삭제한 경우
        let answerText = this.$store.getters.getEnrollStateValue('answerText')
        let answerImg = this.$store.getters.getEnrollStateValue('answerImg')

        // enrollstate 4번째 답변을 3번째 답변으로 복사
        this.$store.commit('setEnrollStateValue', {type: 'answerText', adChoiceNumber: 3, value: {choiceText: answerText[3].choiceText}})
        this.$store.commit('setEnrollStateValue', {type: 'answerImg', adChoiceNumber: 3, value: {choiceImg: answerImg[3].choiceImg}})
      }
      // 4번째 답변 초기화
      this.$store.commit('setEnrollStateValue', {type: 'answerText', adChoiceNumber: 4, value: {choiceText: null}})
      this.$store.commit('setEnrollStateValue', {type: 'answerImg', adChoiceNumber: 4, value: {choiceImg: null}})

      this.$emit('reduceAnswerCount')
      this.$store.commit('setRemoveWatchTrigger')
    }
  },
  mounted: function () {
    this.style.answerContentImgHeight = 'height: ' + this.$refs.answerContentImg.clientWidth * 0.66 + 'px;'
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.answerInputWrapper{
  width: 100%;
  height: 100%;
}

.answerHeader{
  display: flex;
  display: -ms-flexbox;
  justify-content: space-between;
  font-size: 10px;
  margin-bottom: 20px;
}

.answerDeleteText{
  cursor: pointer;
  text-decoration: underline;
}

.answerContentImg{
  width: 100%;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/board/elements/answerInput.vue